import entrepreneurshipReducer from '@admin/features/entrepreneurship/entrepreneurshipSlice';
import kanbanReducer from '@admin/features/entrepreneurship/openChallenge/components/Manage/kanban/kanbanSlice';
import intrapreneurshipReducer from '@admin/features/intrapreneurship/intrapreneurshipSlice';
import userReducer from '@admin/features/user/userSlice';
import { ideaChannelReducer } from '@frontend/feature-idea-channel';
import { configureStore } from '@reduxjs/toolkit';

export const store = configureStore({
  reducer: {
    intrapreneurship: intrapreneurshipReducer,
    entrepreneurship: entrepreneurshipReducer,
    user: userReducer,
    kanban: kanbanReducer,
    ideaChannel: ideaChannelReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
